<!-- Doctors Section -->
<section class="doctors-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12 aos" data-aos="fade-up">
        <div class="section-header-one section-header-slider text-center">
          <h2 class="section-title">{{ 'PORTAL.HOME.DOCTOR-SECTION.TITLE' | translate }}</h2>
        </div>
      </div>
    </div>
    <div
      class="doctor-slider-one owl-theme aos"
      data-aos="fade-up"
      data-aos-duration="2000">
      <div class="row">
        <!-- Doctor Item -->
        @for (data of doctors; track data) {
          <div class="col-md-3 mb-4" >
            <div class="item">
              <div class="doctor-profile-widget doc-item">
                <div class="doc-pro-img">
                  <a routerLink="/doctors/doctor/{{ data.id }}">
                    <div class="doctor-profile-img">
                        <img *ngIf="!data?.image" src="assets/img/no-profile-picture.webp" alt="{{ data.firstName }} {{ data.lastName }}"  class="w-24 h-24 mr-4 border border-gray-300  rounded" />
                        <img *ngIf="data?.image" [src]="data?.image" alt="{{ data.firstName }} {{ data.lastName }}"  class="w-24 h-24 mr-4 border border-gray-300  rounded" />
                    </div>
                  </a>
                </div>
                <div class="doc-content">
                  <div class="doc-pro-info">
                    <div class="doc-pro-name">
                      <a>{{ data.firstName }} {{ data.lastName }}</a>
                      <p>{{ data?.speciality?.label }}</p>

                    </div>
                    <div class="reviews-ratings mt-2">
                      <p>
                      <span><i class="fas fa-star"></i>  {{ data.ratingReview}}</span>
                        ({{ data.nbrReview}})
                      </p>
                    </div>
                  </div>
                  <div class="doc-pro-location">
                    <p>
                      <i class="feather icon-map-pin"></i> {{ data?.city }}
                    </p>
                    <span class="badge badge-success doc-badge"
                    ><i class="fa-solid fa-circle"></i>Ouvert</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- /Doctor Item -->
      </div>
    </div>
  </div>
</section>
<!-- /Doctors Section -->
